import { ApiRequest } from '../baseService'

const BASE_ROUTE = 'app/eml'
const APPOINTMENT_ROUTE = `${BASE_ROUTE}/appointments`

const GetAppointmentById = (emlId: string) => {
  return ApiRequest.get(`${APPOINTMENT_ROUTE}/${emlId}`)
}

const SendNotification = (data: any) => {
  return ApiRequest.post(`${BASE_ROUTE}/notification`, data)
}

const SyncSpecialist = (specialistId: string) => {
  return ApiRequest.post(`${BASE_ROUTE}/sync-specialist/${specialistId}`)
}
const SyncSpecialistData = (specialistId: string) => {
  return ApiRequest.post(`${BASE_ROUTE}/sync-specialist-data/${specialistId}`)
}
const ViewSyncedSpecialistData = (emlSpecialistId: string) => {
  return ApiRequest.get(`${BASE_ROUTE}/specialists/${emlSpecialistId}`)
}

const GetBookingTypes = () => {
  return ApiRequest.get(`${BASE_ROUTE}/booking-types`)
}

const SyncAllSpecialists = () => {
  return ApiRequest.post(`${BASE_ROUTE}/sync-all-specialists`)
}

const BulkSyncAppointments = () => {
  return ApiRequest.post(`${BASE_ROUTE}/bulk-sync-appointments`)
}

const GetSyncedAppointments = (params: any) => {
  return ApiRequest.get(`${BASE_ROUTE}/synced-appointments`, { params })
}

const GetEmlAppointments = (params: any) => {
  return ApiRequest.get(`${BASE_ROUTE}/eml-appointments`, { params })
}

const GetSyncedReport = () => {
  return ApiRequest.get(`${BASE_ROUTE}/synced-report`)
}

const DeleteSpecialistEmlAppointments = (emlSpecialistId: string) => {
  return ApiRequest.delete(
    `${BASE_ROUTE}/specialists/${emlSpecialistId}/appointments`
  )
}

const DeleteEmlSpecialist = (emlSpecialistId: string) => {
  return ApiRequest.delete(`${BASE_ROUTE}/specialists/${emlSpecialistId}`)
}

const FetchAllEmlAppointments = () => {
  return ApiRequest.post(`${BASE_ROUTE}/fetch-appointments?totalItem=200`)
}

const SyncAppointmentData = (appointmentId: string) => {
  return ApiRequest.post(`${BASE_ROUTE}/appointments/${appointmentId}`)
}

const DeleteEmlAppointment = (emlAppointmentId: string) => {
  return ApiRequest.delete(`${BASE_ROUTE}/eml-appointments/${emlAppointmentId}`)
}

const ConfirmBookAppointment = (appointmentId: string) => {
  return ApiRequest.post(
    `${BASE_ROUTE}/appointments/${appointmentId}/confirm-book`
  )
}

const ConfirmBookAppointmentFromMAG = (appointmentId: string) => {
  return ApiRequest.post(
    `${BASE_ROUTE}/appointments/${appointmentId}/confirm-book-from-mag`
  )
}
const MarkAsNotAvailable = (emlAppointmentId: string) => {
  return ApiRequest.post(
    `${BASE_ROUTE}/eml-appointments/${emlAppointmentId}/mark-as-not-available`
  )
}

const SyncAcceptExcludeSessions = () => {
  return ApiRequest.post(`${BASE_ROUTE}/sync-exclude-sessions`)
}

const GetAppointmentReport = (params: any) => {
  return ApiRequest.get(`${BASE_ROUTE}/report-eml-appointments`, { params })
}

const GetNotExistAppointmentInMagReport = () => {
  return ApiRequest.get(`${BASE_ROUTE}/report-not-exist-appointment-in-mag`)
}

const RemoveOrphanedSessions = (emlSessionIds: string[]) => {
  return ApiRequest.post(`${BASE_ROUTE}/remove-orphaned-sessions`, {
    emlSessionIds: emlSessionIds,
  })
}

const RemoveEmlAppointment = (emlSessionId: string) => {
  return ApiRequest.delete(`${BASE_ROUTE}/appointments/${emlSessionId}`)
}

const API = {
  GetAppointmentById,
  SendNotification,
  SyncSpecialistData,
  SyncSpecialist,
  ViewSyncedSpecialistData,
  GetBookingTypes,
  SyncAllSpecialists,
  BulkSyncAppointments,
  GetSyncedAppointments,
  GetEmlAppointments,
  GetSyncedReport,
  DeleteSpecialistEmlAppointments,
  DeleteEmlSpecialist,
  FetchAllEmlAppointments,
  SyncAppointmentData,
  DeleteEmlAppointment,
  ConfirmBookAppointment,
  ConfirmBookAppointmentFromMAG,
  MarkAsNotAvailable,
  SyncAcceptExcludeSessions,
  RemoveOrphanedSessions,
  GetAppointmentReport,
  GetNotExistAppointmentInMagReport,
  RemoveEmlAppointment,
}

export default API
